module.exports = __webpack_public_path__ + "static/bluewhale2-3f5a38746094077a7f9de1dcef6cea88.png";